/**
 * @flow
 * @relayHash 03bb1ad3b9e5650cdebc27f0a74204c5
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SendSystemNotificationMutationVariables = {|
  input: {
    message: string;
    channel?: ?string;
    clientMutationId?: ?string;
  };
|};
export type SendSystemNotificationMutationResponse = {|
  +sendSystemNotification: ?{|
    +clientMutationId: ?string;
  |};
|};
*/

/*
mutation SendSystemNotificationMutation(
  $input: SendSystemNotificationMutationInput!
) {
  sendSystemNotification(input: $input) {
    clientMutationId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  fragment: {
    argumentDefinitions: [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'SendSystemNotificationMutationInput!',
        defaultValue: null,
      },
    ],
    kind: 'Fragment',
    metadata: null,
    name: 'SendSystemNotificationMutation',
    selections: [
      {
        kind: 'LinkedField',
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input',
            type: 'SendSystemNotificationMutationInput!',
          },
        ],
        concreteType: 'SendSystemNotificationMutationPayload',
        name: 'sendSystemNotification',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            args: null,
            name: 'clientMutationId',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ],
    type: 'Mutations',
  },
  id: null,
  kind: 'Batch',
  metadata: {},
  name: 'SendSystemNotificationMutation',
  query: {
    argumentDefinitions: [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'SendSystemNotificationMutationInput!',
        defaultValue: null,
      },
    ],
    kind: 'Root',
    name: 'SendSystemNotificationMutation',
    operation: 'mutation',
    selections: [
      {
        kind: 'LinkedField',
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input',
            type: 'SendSystemNotificationMutationInput!',
          },
        ],
        concreteType: 'SendSystemNotificationMutationPayload',
        name: 'sendSystemNotification',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            args: null,
            name: 'clientMutationId',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ],
  },
  text:
    'mutation SendSystemNotificationMutation(\n  $input: SendSystemNotificationMutationInput!\n) {\n  sendSystemNotification(input: $input) {\n    clientMutationId\n  }\n}\n',
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/SendSystemNotificationMutation.graphql.js